export interface PaginationMeta {
  page: number;
  perPage: number;
  totalItems: number;
  totalPages: number;
}

export interface PaginationParams {
  page?: number;
  perPage?: number;
  search?: string;
}

export const paginationQueryParams = (params: PaginationParams | void) =>
  params
    ? {
        page: params.page,
        per_page: params.perPage,
        search: params.search || undefined,
      }
    : undefined;
